import { addCss } from '@zk/framework-vue';
import { createDriver, resetDriversByNS } from '@zk/framework-vue';
const SCOPED_NAME = 'high-light-menu-driver';

const insertCurrentCss = (options) => {
  const _SCOPED_NAME = `${SCOPED_NAME}-${options.routeName}`;
  return addCss(_SCOPED_NAME, (name) => {
    return `
  .${name} #master-container{
    transform: scale(1);
  }
  #driver-highlighted-element-stage{
    background-color: transparent !important;
  }
  ${options.className}.driver-highlighted-element{
    background: var(--primary-color);
  }
  .${name}#driver-popover-item .driver-popover-tip.left {
    border-color: transparent rgb(111, 109, 237) transparent transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.top {
    border-color: transparent transparent rgb(111, 109, 237) transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.bottom {
    border-color: rgb(111, 109, 237) transparent  transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.right {
    border-color: transparent transparent  transparent rgb(111, 109, 237);
  }
  .guide-popover-left{
    transform: translateX(-8px);
  }
  .guide-popover-right{
    transform: translateX(8px);
  }
  .guide-popover-top{
    transform: translateY(-8px);
  }
  .guide-popover-bottom{
    transform: translateY(8px);
  }
  ${options.className}.driver-highlighted-element {
    border: 2px solid var(--primary-color);
    background: transparent;
    animation: 3s infinite linear scaleBoxShadow;
    transform: translateX(-2px);
    border-radius: 6px !important;
  }
  .zk-confirm-dropdown.driver-highlighted-element{
    // padding: 5px 0 !important;
    // margin-top: -8px !important;
    // margin-bottom: 3px !important;
    background: #fff;
    border-radius: 6px;
    margin-top: -2px !important;;
    margin-bottom: 8px !important;;
  }
  .zk-top-nav__navs ${options.className}.driver-highlighted-element {
    background: #fff;
  }
  ${options.className}.top-nav-automation.driver-highlighted-element{
    transform: translateX(0px);
    background: #fff;
  }
  div.project-list-drawer-create.driver-highlighted-element{
    background: #fff;
    border-radius: 6px !important;
  }
  div.zk-float-add-btn__wrapper.driver-highlighted-element{
    background: #fff;
    transform: translateX(2px) translateY(2px);
  }
  div.zk-left-aside__invite.driver-highlighted-element{
    border-radius: 6px!important;
    transform: none;
  }
  .${name} .driver-popover-title{
    display: none!important;
  }
  div#driver-popover-item.${name} {
    padding: var(--m-large);
    min-width: 288px;
    max-width: unset;
    border-radius: 6px;
    background: rgba(111, 109, 237, 1);
    box-shadow: 0px 6px 12px 0px rgba(96, 97, 132, 0.16);
    color: #fff;
  }
  div#driver-popover-item.${name}::before {
    content: '';
    border-radius: 6px;
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 0;
    background: inherit;
    z-index: -1;
  }
  div#driver-popover-item.${name} .driver-popover-footer {
    padding: 0;
    margin-top:24px;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-btn{
    display: none;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-only-btn{
    display: inline-block;
  }
  div#driver-popover-item.${name} .driver-popover-footer button {
    border-radius: var(--radius-mini);
    border: 0px solid #fff;
    background: var(--primary-color);
    color: #FFF ;
    padding: 4px 16px;
    font-size: 12px !important;
    height: 32px;
    text-shadow: initial !important;
    box-shadow: 0px 2px 10px 2px rgba(99, 96, 230, 0.16);
    border-radius: 16px;
  }
  div#driver-popover-item.${name} .driver-popover-footer button:hover {
    color: var(--font-color-5) !important;
    background-color: var(--brand-color-6);
    border-color: var(--brand-color-6);
  }
  div#driver-popover-item .driver-popover-title {
    font-weight: var(--weight-font-Blod);
    color: #FFFFFF !important;
    line-height: 24px;
    font-size: 18px;
  }
  div#driver-popover-item.${name} .driver-popover-description {
    font-weight: bold !important;
    color: #fff;
    font-size: 14px;
  }
  .guide-popover-automation .driver-popover-tip{
    right: 10px !important;
  }
  .guide-popover-inviteMember .driver-popover-tip{
    left: 15px !important;
  }
  @keyframes scaleBoxShadow{
    0%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }`;
  }, options);
};

const closeDriver = () => resetDriversByNS(SCOPED_NAME, true);


export default {
  data() {
    return {
      driver: null
    };
  },
  beforeDestroy() {
    this.clearDriver();
  },
  methods: {
    highlightMenu (dom, driverTitle, position = 'right-bottom', menuClass, routeName, nextAction) {
      this.nextAction = nextAction;
      if (!dom) {
        console.error('未找到对应的元素');
        return;
      }
      // this.$store.commit('app/SET_IS_GUIDING', true);
      const driver = this.closeModuleGuide(dom, driverTitle, position, menuClass, routeName);
      this.dom = dom;
      this.routeName = routeName;
      if (driver) {
        this.driver = driver;
        this.driver.start();
      }
    },
    clearDriver(e) {
      // setTimeout(() => {
      //   this.$store.commit('app/SET_IS_GUIDING', false);
      // }, 30);
      if (this.nextAction) {
        this.nextAction();
        this.nextAction = null;
        // return;
      }
      if (e && !['more-project', 'more-project-2', 'add-project', 'createIssue'].includes(this.routeName)) {
        this.$emit('hideGuide');
        this.isGuideEnd();
      }
      closeDriver();
      this.driver = null;
      this.dom?.removeEventListener('click', this.clearDriver, true);
      this.driver?.overlay?.node?.removeEventListener('click', this.handleStopClick);
      this.driver?.getHighlightedElement()?.popover?.node?.removeEventListener('click', this.handleStopClick);
    },
    closeModuleGuide(dom, driverTitle, position, menuClass, routeName){
      if (!dom) {
        return;
      }
      const currentCss = insertCurrentCss({ auto: true, className: menuClass, routeName });
      const driver = createDriver(SCOPED_NAME, {
        className: currentCss,
        allowClose: false,
        opacity: 0.2,
        keyboardControl: false,
        onHighlighted: () => {
          setTimeout(() => {
            const popoverNode = driver.getHighlightedElement()?.popover?.node;
            popoverNode?.addEventListener('click', this.handleStopClick);
            driver.overlay?.node.addEventListener('click', this.handleStopClick);
            // 修复筛选条件指引的边界情况
            if (routeName === 'filterTask') {
              const left = parseFloat(popoverNode?.style.left);
              if (popoverNode && left < 0) {
                popoverNode.style.left = 0;
                const tipNode = popoverNode.querySelector('.driver-popover-tip');
                if (tipNode) {
                  tipNode.style.transform = `translateX(${left}px)`;
                }
              }
            }
          });
                   
        }
      });
    
      const steps = [{
        element: dom,
        // element: el,
        popover: {
          className: `guide-popover-${position.split('-')[0]} guide-popover-${routeName}`,
          title: ' ',
          // offset: 10,
          description: driverTitle,
          position,
          showButtons: false,
          closeBtnText: this.$t('guide.button.know')
        },
        onHighlightStarted: () => {
          dom.addEventListener('click', this.clearDriver, true);
        }
      }];
    
      driver.defineSteps(steps);
      return driver;
    },
    handleStopClick(e){
      e.stopPropagation();
    }
  }
};
